import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Sampletesttable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.sampletesttable_Id,
          sortable: true,
          cell: (row) => <span>{row.sampletesttable_Id}</span>,
        },
        { name: "Name", selector: (row, i) => row.name, sortable: true, cell: (row) => <span>{row.name}</span>, }, { name: "Number", selector: (row, i) => row.number, sortable: true, cell: (row) => <span>{row.number}</span>, }, { name: "Mobile", selector: (row, i) => row.mobile, sortable: true, cell: (row) => <span>{row.mobile}</span>, }, { name: "Password", selector: (row, i) => row.password, sortable: true, cell: (row) => <span>{row.password}</span>, }, { name: "File Uploader", selector: (row, i) => row.fileuploader, sortable: true, cell: (row) => <span>{row.fileuploader}</span>, }, { name: "Mail", selector: (row, i) => row.mail, sortable: true, cell: (row) => <span>{row.mail}</span>, }, { name: "Date Of Birth", selector: (row, i) => row.dateofbirth, sortable: true, cell: (row) => <span>{row.dateofbirth}</span>, }, { name: "Date Of Child", selector: (row, i) => row.dateofchild, sortable: true, cell: (row) => <span>{row.dateofchild}</span>, }, { name: "Date Of Adult", selector: (row, i) => row.dateofadult, sortable: true, cell: (row) => <span>{row.dateofadult}</span>, }, { name: "Pan Number", selector: (row, i) => row.pannumber, sortable: true, cell: (row) => <span>{row.pannumber}</span>, }, { name: "Aadhaar Number", selector: (row, i) => row.aadhaarnumber, sortable: true, cell: (row) => <span>{row.aadhaarnumber}</span>, }, { name: "gender", selector: (row, i) => row.gender, sortable: true, cell: (row) => <span>{row.gender}</span>, }, { name: "Task Projecds", selector: (row, i) => row.tasksprojects, sortable: true, cell: (row) => <span>{row.tasksprojects}</span>, }, { name: "Templates", selector: (row, i) => row.templates, sortable: true, cell: (row) => <span>{row.templates}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.SampletesttableeditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      sampletesttable_Id: "",
      name: '', number: '', mobile: '', password: '', fileuploader: '', mail: '', dateofbirth: '', dateofchild: '', dateofadult: '', pannumber: '', aadhaarnumber: '', gender: '', ittaskstable: [], tasksprojects: '', templates: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Check required fields
    const requiredFields = ['name', 'number', 'mobile', 'password', 'fileuploader', 'mail', 'dateofbirth', 'dateofchild', 'dateofadult', 'pannumber', 'aadhaarnumber', 'gender', 'tasksprojects', 'templates'];
    for (const field of requiredFields) {
      if (!this.state[field] || this.state[field].toString().trim() === '') {
        return false;
      }
    }

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'name', inputType: 'text', validationOptions: { isRequired: true, isName: true } },
      { fieldName: 'number', inputType: 'number', validationOptions: { isRequired: true } },
      { fieldName: 'mobile', inputType: 'telephone', validationOptions: { isRequired: true } },
      { fieldName: 'password', inputType: 'password', validationOptions: { isRequired: true } },
      { fieldName: 'mail', inputType: 'mail', validationOptions: { isRequired: true } },
      { fieldName: 'dateofbirth', inputType: 'date', validationOptions: { isRequired: true } },
      { fieldName: 'dateofchild', inputType: 'dob_child', validationOptions: { isRequired: true } },
      { fieldName: 'dateofadult', inputType: 'dob_adult', validationOptions: { isRequired: true } },
      { fieldName: 'pannumber', inputType: 'pan', validationOptions: { isRequired: true } },
      { fieldName: 'aadhaarnumber', inputType: 'aadhaar', validationOptions: { isRequired: true } },
      { fieldName: 'gender', inputType: 'text', validationOptions: { isRequired: true } },
      { fieldName: 'tasksprojects', inputType: 'text', validationOptions: { isRequired: true } },
      { fieldName: 'templates', inputType: 'text', validationOptions: { isRequired: true } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    // Mark all fields as touched
    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      name: '', number: '', mobile: '', password: '', fileuploader: '', mail: '', dateofbirth: '', dateofchild: '', dateofadult: '', pannumber: '', aadhaarnumber: '', gender: '', ittaskstable: [], tasksprojects: '', templates: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      name: '', number: '', mobile: '', password: '', fileuploader: '', mail: '', dateofbirth: '', dateofchild: '', dateofadult: '', pannumber: '', aadhaarnumber: '', gender: '', ittaskstable: [], tasksprojects: '', templates: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  SampletesttableeditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      sampletesttable_Id: row.sampletesttable_Id,
      name: row.name, number: row.number, mobile: row.mobile, password: row.password, fileuploader: row.fileuploader, mail: row.mail, dateofbirth: row.dateofbirth, dateofchild: row.dateofchild, dateofadult: row.dateofadult, pannumber: row.pannumber, aadhaarnumber: row.aadhaarnumber, gender: row.gender, ittaskstable: [], tasksprojects: row.tasksprojects, templates: row.templates,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  SampletesttablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Sampletesttable/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  SampletesttablesubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('name', this.state.name);
    formData.append('number', this.state.number);
    formData.append('mobile', this.state.mobile);
    formData.append('password', this.state.password);
    formData.append('fileuploader', this.state.fileuploader);
    formData.append('mail', this.state.mail);
    formData.append('dateofbirth', this.state.dateofbirth);
    formData.append('dateofchild', this.state.dateofchild);
    formData.append('dateofadult', this.state.dateofadult);
    formData.append('pannumber', this.state.pannumber);
    formData.append('aadhaarnumber', this.state.aadhaarnumber);
    formData.append('gender', this.state.gender);
    formData.append('tasksprojects', this.state.tasksprojects);
    formData.append('templates', this.state.templates);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Sampletesttable/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.SampletesttablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({ name: '', number: '', mobile: '', password: '', fileuploader: '', mail: '', dateofbirth: '', dateofchild: '', dateofadult: '', pannumber: '', aadhaarnumber: '', gender: '', ittaskstable: [], tasksprojects: '', templates: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  SampletesttableupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("sampletesttable_Id", this.state.sampletesttable_Id);
    formData.append('name', this.state.name);
    formData.append('number', this.state.number);
    formData.append('mobile', this.state.mobile);
    formData.append('password', this.state.password);
    formData.append('fileuploader', this.state.fileuploader);
    formData.append('mail', this.state.mail);
    formData.append('dateofbirth', this.state.dateofbirth);
    formData.append('dateofchild', this.state.dateofchild);
    formData.append('dateofadult', this.state.dateofadult);
    formData.append('pannumber', this.state.pannumber);
    formData.append('aadhaarnumber', this.state.aadhaarnumber);
    formData.append('gender', this.state.gender);
    formData.append('tasksprojects', this.state.tasksprojects);
    formData.append('templates', this.state.templates);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Sampletesttable/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.SampletesttablefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.SampletesttablefetchHandler();
    this.ittaskstablefetchHandler();

    //***componentDidMount
  }

  handlenameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ name: fieldValue });
  }; handlenumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ number: fieldValue });
  }; handlemobileChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mobile: fieldValue });
  }; handlepasswordChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ password: fieldValue });
  }; handlefileuploaderChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ fileuploader: fieldValue });
  }; handlemailChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ mail: fieldValue });
  }; handledateofbirthChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dateofbirth: fieldValue });
  }; handledateofchildChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dateofchild: fieldValue });
  }; handledateofadultChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dateofadult: fieldValue });
  }; handlepannumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pannumber: fieldValue });
  }; handleaadhaarnumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aadhaarnumber: fieldValue });
  }; handlegenderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ gender: fieldValue });
  }; handletasksprojectsChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ tasksprojects: fieldValue });
  }; ittaskstablefetchHandler = () => {
    fetch(configData.api_url + "C_Ittaskstable/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ ittaskstable: data.list });
        }
      });
  }; handletemplatesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ templates: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this sampletesttable?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('sampletesttable_Id', row.sampletesttable_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Sampletesttable/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.SampletesttablefetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Sample Test Table</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Sampletesttable</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenameChange} className="form-control" name="name" value={this.state.name} required="required" placeholder="Enter Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenumberChange} className="form-control" name="number" value={this.state.number} required="required" placeholder="Enter Number" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.number} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Mobile</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlemobileChange} className="form-control" name="mobile" value={this.state.mobile} required="required" placeholder="Enter Mobile" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mobile} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Password</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="password" onChange={this.handlepasswordChange} className="form-control" name="password" value={this.state.password} required="required" placeholder="Enter Password" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.password} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>File Uploader</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="file" onChange={this.handlefileuploaderChange} className="form-control" name="fileuploader" value={this.state.fileuploader} required="required" placeholder="Enter File Uploader" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.fileuploader} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Mail</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="mail" onChange={this.handlemailChange} className="form-control" name="mail" value={this.state.mail} required="required" placeholder="Enter Mail" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mail} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Of Birth</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledateofbirthChange} className="form-control" name="dateofbirth" value={this.state.dateofbirth} required="required" placeholder="Enter Date Of Birth" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dateofbirth} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Of Child</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledateofchildChange} className="form-control" name="dateofchild" value={this.state.dateofchild} required="required" placeholder="Enter Date Of Child" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dateofchild} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Of Adult</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledateofadultChange} className="form-control" name="dateofadult" value={this.state.dateofadult} required="required" placeholder="Enter Date Of Adult" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dateofadult} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Pan Number</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlepannumberChange} className="form-control" name="pannumber" value={this.state.pannumber} required="required" placeholder="Enter Pan Number" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pannumber} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Number</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleaadhaarnumberChange} className="form-control" name="aadhaarnumber" value={this.state.aadhaarnumber} required="required" placeholder="Enter Aadhaar Number" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarnumber} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>gender</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlegenderChange} className="form-control" name="gender" value={this.state.gender} required="required" placeholder="Enter gender" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.gender} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Task Projecds</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handletasksprojectsChange}>
                                        <option defaultValue> Select Task Projecds </option>
                                        {this.state.ittaskstable.map((api, index, idx) => (
                                          <option key={index} value={api.projectName}> {api.projectName} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tasksprojects} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Templates</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletemplatesChange} className="form-control" name="templates" value={this.state.templates} required="required" placeholder="Enter Templates" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.templates} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.SampletesttablesubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Sampletesttable</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenameChange} className="form-control" name="name" value={this.state.name} required="required" placeholder="Enter Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenumberChange} className="form-control" name="number" value={this.state.number} required="required" placeholder="Enter Number" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.number} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Mobile</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlemobileChange} className="form-control" name="mobile" value={this.state.mobile} required="required" placeholder="Enter Mobile" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mobile} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Password</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="password" onChange={this.handlepasswordChange} className="form-control" name="password" value={this.state.password} required="required" placeholder="Enter Password" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.password} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>File Uploader</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="file" onChange={this.handlefileuploaderChange} className="form-control" name="fileuploader" value={this.state.fileuploader} required="required" placeholder="Enter File Uploader" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.fileuploader} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Mail</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="mail" onChange={this.handlemailChange} className="form-control" name="mail" value={this.state.mail} required="required" placeholder="Enter Mail" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mail} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Of Birth</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledateofbirthChange} className="form-control" name="dateofbirth" value={this.state.dateofbirth} required="required" placeholder="Enter Date Of Birth" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dateofbirth} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Of Child</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledateofchildChange} className="form-control" name="dateofchild" value={this.state.dateofchild} required="required" placeholder="Enter Date Of Child" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dateofchild} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Of Adult</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledateofadultChange} className="form-control" name="dateofadult" value={this.state.dateofadult} required="required" placeholder="Enter Date Of Adult" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dateofadult} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Pan Number</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlepannumberChange} className="form-control" name="pannumber" value={this.state.pannumber} required="required" placeholder="Enter Pan Number" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.pannumber} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Aadhaar Number</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleaadhaarnumberChange} className="form-control" name="aadhaarnumber" value={this.state.aadhaarnumber} required="required" placeholder="Enter Aadhaar Number" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.aadhaarnumber} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>gender</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlegenderChange} className="form-control" name="gender" value={this.state.gender} required="required" placeholder="Enter gender" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.gender} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Task Projecds</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handletasksprojectsChange}>
                                          <option defaultValue> Select Task Projecds </option>
                                          {this.state.ittaskstable.map((api, index, idx) => (
                                            <option key={index} value={api.projectName}> {api.projectName} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tasksprojects} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Templates</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletemplatesChange} className="form-control" name="templates" value={this.state.templates} required="required" placeholder="Enter Templates" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.templates} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.SampletesttableupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}